import { useState } from 'react';

import SuiPng from '@/assets/png/web3/sui.png';
import { Typography } from '@/design-system';

import { CoinArtwork, IconRoot, SuiGlyph } from './coin-icon.styled';

export const CoinIcon = ({
  symbol,
  iconUrl,
  size = 28,
}: {
  symbol: string;
  iconUrl?: string | null;
  size?: number;
}) => {
  const isSui = symbol.toUpperCase() === 'SUI';
  const [failedIconUrl, setFailedIconUrl] = useState<string | null>(null);
  const resolvedIconUrl = iconUrl === failedIconUrl ? null : iconUrl;

  return (
    <IconRoot $size={size} $isSui={isSui}>
      {isSui ? (
        <SuiGlyph
          src={resolvedIconUrl ?? SuiPng}
          alt={symbol}
          onError={resolvedIconUrl ? () => setFailedIconUrl(resolvedIconUrl) : undefined}
        />
      ) : resolvedIconUrl ? (
        <CoinArtwork
          src={resolvedIconUrl}
          alt={symbol}
          onError={() => setFailedIconUrl(resolvedIconUrl)}
        />
      ) : (
        <Typography variant="body3" fontWeight={600}>
          {symbol.slice(0, 1)}
        </Typography>
      )}
    </IconRoot>
  );
};
